import React, { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { shopApi, shopError } from "../lib/shop";
import { ButtonRing } from "./LoadingRing";

export const NotifyMe = ({ productSlug, productName }) => {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await shopApi.post("/notify-me", { product_slug: productSlug, email: email.trim() });
            setDone(true);
            toast.success("We'll email you the moment it launches");
        } catch (err) {
            toast.error(shopError(err));
        } finally {
            setBusy(false);
        }
    };

    if (done) {
        return (
            <div className="border border-lime/40 bg-lime/5 p-5" data-testid="notify-me-success">
                <div className="mono text-[10px] tracking-[0.18em] text-lime">YOU'RE ON THE LIST</div>
                <p className="text-sm text-zinc-300 mt-2">
                    We'll let you know as soon as {productName} is available.
                </p>
            </div>
        );
    }

    return (
        <form onSubmit={submit} className="border border-gold/40 bg-gold/5 p-5" data-testid="notify-me-form">
            <div className="flex items-center gap-2 mono text-[10px] tracking-[0.18em] text-gold">
                <BellRing className="w-3.5 h-3.5" /> COMING SOON
            </div>
            <p className="text-sm text-zinc-300 mt-2">
                {productName} isn't on sale yet. Leave your email and we'll notify you first.
            </p>
            <div className="flex gap-2 mt-4">
                <input
                    type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com" data-testid="notify-me-email"
                    className="flex-1 bg-bg0 border border-white/10 px-3 py-2.5 text-sm outline-none focus:border-gold"
                />
                <button type="submit" disabled={busy} className="btn-pill btn-primary !py-2.5" data-testid="notify-me-submit">
                    {busy ? <ButtonRing /> : "NOTIFY ME"}
                </button>
            </div>
        </form>
    );
};
